
import { usage } from "~/data/disasterRecovery";

export default {
  data() {
    return {
      usage,
    };
  },
};
